import { render } from "./PularParaConteudo.vue?vue&type=template&id=10487b8d&scoped=true"
const script = {}

import "./PularParaConteudo.vue?vue&type=style&index=0&id=10487b8d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10487b8d"]])

export default __exports__